module.exports = __webpack_public_path__ + "img/donni.838bedfd.png";